import { Modal, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

interface ModalWarningEditTimeKeepingProps {
  isOpen: boolean;
  err?: {
    dates?: string[];
  };
  onClose: () => void;
}

const ModalWarningEditTimeKeeping: React.FC<ModalWarningEditTimeKeepingProps> = ({
  isOpen, onClose,
  err = {},
}) => (
  <Modal
    open={isOpen}
    onCancel={onClose}
    footer={null}
    width={600}
  >
    <Typography.Title type="danger" level={3} style={{ textAlign: 'center', marginBottom: '16px' }}>
      Thay đổi không thành công
    </Typography.Title>
    <Typography.Paragraph style={{ textAlign: 'center', fontSize: 14 }}>
      Kỳ chấm công này đã phát sinh chấm công cho các ngày:
      <br />
      {err?.dates?.map((i) => dayjs(i).format('DD/MM/YYYY')).join(', ')}
      <br />
      Để thay đổi thời gian kỳ chấm công, vui lòng cập nhật ngày công cho các ngày này về 0.
    </Typography.Paragraph>
  </Modal>
);

export default ModalWarningEditTimeKeeping;
